import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { networkLogos } from 'src/constants/networkLogos'
import { sportIds, leagueIds, teamIds } from 'src/constants/personalizationIds'

export default (props) => {
  return (
    <USTemplateDefault
      location={props.location}
      video={
        'https://assets.fubo.tv/marketing/lp/videos/compressed/SeattleKraken2022_1280x720_LP_15s.mp4'
      }
      staticAnnotation={networkLogos.kong}
      title="Watch Seattle Kraken hockey"
      subtitle="Get live games, local team coverage & more. Regional restrictions apply."
      networkSet="hockey"
      customNetworks={['rootsports']}
      sportId={sportIds.Hockey}
      leagueId={leagueIds.NHL}
      teamId={teamIds['Seattle Kraken']}
    />
  )
}
